import React from 'react';

import { MembershipType, PersonOrgSubtype } from '@ndvr/customer-api';

import { FormInput, FormSection, FormSelect, getFieldName, StateSelector, Title, VerticalLayout } from 'widgets';
import { FormDateInput } from 'widgets/form/input/FormDateInput';

import { AddressBlock } from './AddressBlock';
import { AuthorizationFields } from './AuthorizationFields';
import { ComplianceRequirements } from './ComplianceRequirements';
import { FinancialPicture } from './FinancialPicture';
import { MemberSelector } from './MemberSelector';

export const EntityFormFields = ({ prefix = '' }: { prefix?: string }) => {
    return (
        <VerticalLayout $gap={24}>
            <FormSection title="Entity details">
                <FormSelect name={getFieldName('personOrgSubtype', prefix)} label="Entity type">
                    <option></option>
                    <option value={PersonOrgSubtype.NON_PROFIT_ORGANIZATION}>Non-Profit Organization</option>
                    <option value={PersonOrgSubtype.INCORPORATED_COMPANY}>Corporation</option>
                    <option value={PersonOrgSubtype.LIMITED_LIABILITY_COMPANY}>LLC</option>
                    <option value={PersonOrgSubtype.PARTNERSHIP}>Partnership</option>
                </FormSelect>
                <FormInput name={getFieldName('orgName', prefix)} placeholder="Name" label="Entity name" />
                <FormDateInput
                    name={getFieldName('establishedAt', prefix)}
                    label="Date of Incorporation / Establishment"
                />
                <StateSelector name={getFieldName('orgState', prefix)} label="State Organized in" />
            </FormSection>

            <FormSection title="Management Authorization" hasDivider>
                <AuthorizationFields prefix={prefix} label="Entity" />
            </FormSection>

            <FormSection hasDivider>
                <VerticalLayout $gap={32}>
                    <Title content>Entity Members</Title>
                    <MemberSelector
                        prefix={prefix}
                        title="Presidents"
                        membershipType={MembershipType.PRESIDENT}
                        showPercentageField
                    />
                    <MemberSelector
                        prefix={prefix}
                        title="Directors"
                        membershipType={MembershipType.DIRECTOR}
                        showPercentageField
                    />
                    <MemberSelector
                        prefix={prefix}
                        title="Managing owners"
                        membershipType={MembershipType.MANAGING_OWNER}
                        showPercentageField
                    />
                    <MemberSelector
                        prefix={prefix}
                        title="Beneficial Owners"
                        membershipType={MembershipType.BENEFICIAL_OWNER}
                        showPercentageField
                    />
                </VerticalLayout>
            </FormSection>

            <AddressBlock prefix={prefix} />

            <FormSection title="Financial Picture" hasDivider>
                <FinancialPicture prefix={prefix} />
            </FormSection>

            <FormSection title="Compliance Requirements" hasDivider>
                <ComplianceRequirements prefix={prefix} />
            </FormSection>
        </VerticalLayout>
    );
};
